// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  RESET_ADDRESS_STATE: 'RESET_ADDREESS_STATE',
  ADD_USER_ADDRESS_REQ: 'ADD_USER_ADDRESS_REQ',
  ADD_USER_ADDRESS_SUCCESS: 'ADD_USER_ADDRESS_SUCCESS',
  ADD_USER_ADDRESS_FAIL: 'ADD_USER_ADDRESS_FAIL',
  UPDATE_USER_ADDRESS_REQ: 'UPDATE_USER_ADDRESS_REQ',
  COUNTRY_US: 'US',
  COUNTRY_CA: 'CA',
  ADDRESS_FORM: 'AddressForm',
};
